/** Minimum match cards per round so the playoff graph keeps a stable layout.
 * Upper bracket stops at round 2 (winner advances to grand final).
 * Lower bracket keeps rounds 1–3. */
export const PLAYOFF_MIN_SLOTS = {
  UPPER: [2, 1] as const,
  LOWER: [2, 1, 1] as const,
} as const;

/** Valid bracket rounds for playoff matches (4 = grand final). Upper has no round 3. */
export const PLAYOFF_BRACKET_ROUNDS = {
  UPPER: [1, 2, 4] as const,
  LOWER: [1, 2, 3, 4] as const,
} as const;

export const playoffRoundsForBracket = (bracket: string | undefined): readonly number[] => {
  if (bracket === "UPPER" || bracket === "LOWER") {
    return PLAYOFF_BRACKET_ROUNDS[bracket];
  }
  return PLAYOFF_BRACKET_ROUNDS.LOWER;
};
